import { Component, OnInit, Input } from '@angular/core';
import { BEDataService } from '../../services/businessEvent/beData.service';

@Component({
    selector: 'app',
    template: require('./app.component.html'),
    styles: [require('./app.component.css')]
})

export class AppComponent implements OnInit {
    private _title = 'Business Event wizard';
    @Input() _businessEventData: any;

    constructor(private _beDataService: BEDataService) {
    }

    ngOnInit() {
        this._businessEventData = this._beDataService.getBusinessEvent();
    }
}
